export default __webpack_public_path__ + "static/media/img_about_us.3fd996bd.png";